import { type FC } from "react";

import { Button } from "@styled/button";

import { useAsk } from "./use_ask";

// Under the chat's latest citations to check: asking the assistant about them
// (and the rest of Items to check) is this button's alone, never the list's.
export const AskAboutCitations: FC = () => {
  const ask = useAsk();
  if (!ask) return null;

  return (
    <Button
      type="button"
      color="white"
      size="xs"
      disabled={ask.disabled}
      onClick={() => ask.onAsk("Items to check")}
    >
      Ask the assistant about these
    </Button>
  );
};
